// /frontend/src/components/AgentExecutionReportModal.js

import React from 'react';
import styles from './TranslationAnalysisModal.module.css'; // Reuse existing styles!
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faRobot,
  faLanguage,
  faPaperPlane,
  faCheckCircle,
  faTimesCircle, // New
  faExclamationTriangle, // New
} from '@fortawesome/free-solid-svg-icons';
import ReactMarkdown from 'react-markdown';

const AgentExecutionReportModal = ({ isOpen, onClose, traceData }) => {
  if (!isOpen || !traceData) return null;

  const {
    step_1_intent,
    step_2_draft,
    step_3_translation,
    step_4_execution,
    step_5_followup,
  } = traceData;

  return (
    <div className={`${styles.modalOverlay} ${styles.show}`} onClick={onClose}>
      <div
        className={`${styles.modalContent} ${styles.show}`}
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '900px' }}
      >
        <div className={styles.modalHeader}>
          <h3>
            <FontAwesomeIcon icon={faRobot} /> Agent Execution Report
          </h3>
          <button onClick={onClose} className={styles.closeButton}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div
          className={styles.loadingContainer}
          style={{ textAlign: 'left', maxHeight: '70vh', overflowY: 'auto' }}
        >
          {/* 1. INTENT */}
          {step_1_intent && (
            <div
              style={{
                marginBottom: '20px',
                padding: '15px',
                background: '#2c3046',
                borderRadius: '8px',
              }}
            >
              <h4 style={{ color: '#6f9aee' }}>1. Intent Analysis</h4>
              <p>
                <strong>Channel:</strong>{' '}
                {step_1_intent.detected_channel || 'Auto-Detect'}
              </p>
              <p>
                <strong>Follow-Up:</strong>{' '}
                {step_1_intent.detected_followup || 'None'}
              </p>
            </div>
          )}

          {/* 2. DRAFT (Collapsed or Summarized) */}
          <div style={{ marginBottom: '20px' }}>
            <h4 style={{ color: '#6f9aee', borderBottom: '1px solid #444' }}>
              2. Generated Draft (English)
            </h4>
            <div
              className={styles.readOnlyContent}
              style={{ maxHeight: '150px' }}
            >
              <ReactMarkdown>{step_2_draft?.content}</ReactMarkdown>
            </div>
          </div>

          {/* 3. TRANSLATION & RATIONALE */}
          {step_3_translation?.target_language && (
            <div style={{ marginBottom: '20px' }}>
              <h4 style={{ color: '#6f9aee', borderBottom: '1px solid #444' }}>
                <FontAwesomeIcon icon={faLanguage} /> Translation (
                {step_3_translation.target_language})
              </h4>

              {step_3_translation.rationale && (
                <div
                  style={{
                    marginBottom: '10px',
                    padding: '10px',
                    background: '#232532',
                    borderLeft: '4px solid #6f9aee',
                  }}
                >
                  <strong>Agent Rationale:</strong>
                  <ReactMarkdown>{step_3_translation.rationale}</ReactMarkdown>
                </div>
              )}

              <div
                className={styles.readOnlyContent}
                style={{ maxHeight: '200px' }}
              >
                <p>
                  <strong>Subject:</strong>{' '}
                  {step_3_translation.translated_subject}
                </p>
                <ReactMarkdown>
                  {step_3_translation.translated_body}
                </ReactMarkdown>
              </div>
            </div>
          )}

          {/* 4. OUTCOME */}
          <div
            style={{
              marginTop: '20px',
              paddingTop: '10px',
              borderTop: '1px solid #555',
              display: 'flex',
              flexDirection: 'column', // Changed to column to handle error text better
              gap: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <div>
                <h4 style={{ margin: 0 }}>
                  <FontAwesomeIcon icon={faPaperPlane} /> Outcome
                </h4>
                {/* CONDITIONAL RENDERING FOR STATUS */}
                {step_4_execution?.status &&
                step_4_execution.status.toLowerCase().includes('sent') ? (
                  <span
                    style={{
                      color: '#28a745',
                      fontSize: '1.1em',
                      marginTop: '5px',
                      display: 'block',
                    }}
                  >
                    <FontAwesomeIcon icon={faCheckCircle} />{' '}
                    {step_4_execution.status}
                  </span>
                ) : (
                  <span
                    style={{
                      color: '#d32f2f',
                      fontSize: '1.1em',
                      marginTop: '5px',
                      display: 'block',
                    }}
                  >
                    <FontAwesomeIcon icon={faTimesCircle} />{' '}
                    {step_4_execution?.status || 'Failed'}
                  </span>
                )}
              </div>

              {step_5_followup?.date && (
                <div style={{ textAlign: 'right' }}>
                  <h4 style={{ margin: 0 }}>Next Step</h4>
                  <span style={{ color: '#e0e0e0' }}>
                    ToDo set for: {step_5_followup.date}
                  </span>
                </div>
              )}
            </div>

            {/* ERROR MESSAGE DISPLAY */}
            {step_4_execution?.error && (
              <div
                style={{
                  background: 'rgba(211, 47, 47, 0.1)',
                  border: '1px solid #d32f2f',
                  padding: '10px',
                  borderRadius: '5px',
                  color: '#ff8a80',
                  fontSize: '0.9em',
                }}
              >
                <strong>
                  <FontAwesomeIcon icon={faExclamationTriangle} /> Error
                  Details:
                </strong>
                <p style={{ margin: '5px 0 0 0' }}>{step_4_execution.error}</p>
              </div>
            )}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button onClick={onClose} className={styles.footerButton}>
            Close Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentExecutionReportModal;
